var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-nav"},[_c('ul',{staticClass:"page-nav__list"},_vm._l((_vm.navList),function(item,index){return _c('li',{key:index,staticClass:"page-nav__item"},[_c('router-link',{staticClass:"page-nav__link",attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.name)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }